<template>
    <div v-if="isApplicationOutdated" class="w-100" style="position: fixed; top: 100px; z-index: 1001;">
        <b-container>
            <b-alert show variant="warning">
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                        Es wurde eine neue Version veröffentlicht.
                        Bitte Laden Sie autoclaim neu, um Probleme zu vermeiden.
                    </div>
                    <div>
                        <b-button variant="secondary" @click="reloadApplication">
                            Hier neu laden
                        </b-button>
                    </div>
                </div>
            </b-alert>
        </b-container>
    </div>
</template>

<script>
    import Container from '@services/Container';

    export default {
        data() {
            return {
                initialVersion: '',
                currentVersion: '',
                urlParams: null,
            }
        },
        computed: {
            isApplicationOutdated() {
                if (!this.currentVersion) {
                    return false;
                }
                return this.initialVersion !== this.currentVersion;
            },
        },
        mounted() {
            const container = Container.getInstance();
            this.eventBus = container.getEventBus();
            this.eventBus.on('ajax-success', this.checkApplicationVersion);

            this.initialVersion = this.$root.appVersion;
            this.urlParams = new URLSearchParams(window.location.search);
            if (this.urlParams.has('v')) {
                this.initialVersion = this.urlParams.get('v');
            }
        },
        beforeDestroy() {
            this.eventBus.off('ajax-success', this.checkApplicationVersion);
        },
        methods: {
            buildCurrentUrlParam(param) {
                return this.urlParams.get(param) ? '&' + param + '=' + this.urlParams.get(param) : ''
            },
            checkApplicationVersion(response) {
                if (!response.meta) {
                    return;
                }
                if (!response.meta.version) {
                    return;
                }

                this.currentVersion = response.meta.version;
            },
            reloadApplication() {
                window.location.href = '/build/csp-app/index.html?v='
                    + this.currentVersion
                    + this.buildCurrentUrlParam('mode');
            },
        },
    }
</script>
